export enum AnalyticsAction {
  EDIT_VEHICLE = 'edit vehicle',
  ADD_NEW_VEHICLE ='Add New vehicle',
  ADD_MISSING_INFORMATION = 'Add missing information',
  OPEN_ORDER_CREATION_WIZARD = 'open order creation Wizard',
  EDITING_AN_ORDER = 'Editing an Order',
  INSTALLATION_EDITED = 'Installation Edited',
  USER_OPEN_SHOPPING_CART = 'User open shopping Cart',
  CREATED_WITH_PQL_PARTS = 'Created with PQL parts',
  CREATED_ADMIN_APPROVAL_NEEDED = 'Created-needs admin appr',
  CREATE_PROVIDER_APPROVAL_NEEDED = 'Created-needs prov appr',
  CREATED = 'Created',
  USING_MOBILE_VERSION = 'Using mobile version',
  USING_DESKTOP_VERSION = 'Using desktop version',
}
